import { BpOptionConstantS } from '../../../../BpOption/S/Constant/module/BpOptionConstantS.js';
import { go, head, html, last, map, pluck } from 'fxjs/es';
import { BpDiscountSetS } from '../../../../BpDiscountSet/S/Function/module/BpDiscountSetS.js';
import { BpOptionTmplS } from '../../../../BpOption/S/Tmpl/module/BpOptionTmplS.js';
import $dataStr from 'fxdom/es/dataStr.js';
import { BpDiscountSetConstantS } from '../../../../BpDiscountSet/S/Constant/module/BpDiscountSetConstantS.js';
import { getIsBizProduct } from '../../../../Maker/S/product.js';

export const makeQuantityHtml = ({ qty, bp_discount_set, product_color }) => {
  const { is_pure_biz_product } = getIsBizProduct(product_color);
  const bp_discount_ranges = bp_discount_set?._?.bp_discount_ranges;
  const min_qty = head(bp_discount_ranges)?.start;
  const max_qty = last(bp_discount_ranges)?.end;
  const is_show_discount_guide =
    bp_discount_set?.type !== BpDiscountSetConstantS.TYPE.MP_WOW &&
    /* 가격표 보여주는 부분 */
    bp_discount_ranges?.length > 1;

  return html`
    <div
      class="section ${BpOptionConstantS.BIZ_OPTION_MENU_KEY.QTY} ${BpOptionConstantS.BIZ_OPTION_MENU_TITLE}"
      style="${!is_pure_biz_product ? 'display:none;' : ''}"
    >
      <div class="head">${TT('biz::opt::title::qty')}</div>
      <div class="body">
        <div class="qty_wrap">
          ${BpDiscountSetS.util.isStepTypeBpDiscountRanges(bp_discount_ranges)
            ? BpOptionTmplS.makeSelectQuantityHtml({
                quantities: go(bp_discount_ranges, pluck('start')),
                quantity: qty,
                min: min_qty,
                max: max_qty,
              })
            : html`
                <div class="input_wrap">
                  <button name="minus"></button>
                  <input
                    type="number"
                    class="quantity"
                    value="${Number(qty)}"
                    min="${min_qty}"
                    max="${max_qty}"
                    step="${1}"
                    inputmode="numeric"
                    pattern="[0-9]*"
                  />
                  <button name="plus"></button>
                </div>
              `}
        </div>
        ${is_show_discount_guide
          ? html`<div class="group_discount_guide">
              <button
                class="group_discount_guide"
                data-fx-json="${$dataStr(
                  go(
                    bp_discount_ranges,
                    map((d) => ({
                      qty: d.start,
                      price: parseFloat(d['price' + G._en]) + parseFloat(d['min_option_price' + G._en]),
                    })),
                  ),
                )}"
              >
                ${TT('biz::opt::group_discount')}
              </button>
            </div>`
          : ``}
      </div>
      <div class="footer">
        <span>${min_qty}${TT('biz::opt::ea')}${TT('biz::opt::order')}</span>
      </div>
    </div>
  `;
};
